export const getOrder = (key: string) => {
  if (key === "CRITICAL") {
    return 0;
  }
  if (key === "HIGH") {
    return 1;
  }
  if (key === "MEDIUM") {
    return 2;
  }
  if (key === "LOW") {
    return 3;
  }
  if (key === "INFO") {
    return 4;
  }
};

export const chartStats = (edges: any[]) => {
  function* transports() {
    for (const edge of edges) {
      yield edge.node.classification?.identifier || "Unknown";
    }
  }
  function* classifications() {
    for (const edge of edges) {
      yield edge.node.severity || "INFO";
    }
  }

  const t = [...transports()];
  const c = [...classifications()];
  const percentageOf = (value: number) => Number(((value / c.length) * 100).toFixed(1));
  return {
    transports: [...new Set(t)].map((key) => ({
      name: key,
      value: t.filter((item) => item === key).length,
    })),
    classifications: [...new Set(c)].map((key) => ({
      name: key,
      order: getOrder(key),
      value: percentageOf(c.filter((item) => item === key).length),
      percentage: percentageOf(c.filter((item) => item === key).length),
    })),
  };
};
